import { render } from "./DDeposito.vue?vue&type=template&id=1a22fb42"
import script from "./DDeposito.vue?vue&type=script&lang=js"
export * from "./DDeposito.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__